import { Direction } from 'webapp/enums/enums';
import { TourDoneKey, TourId } from 'webapp/enums/tour';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class DesignerResizeBlockTour extends TourBase {
	static keyForPersistantDone = TourDoneKey.DESIGNER__RESIZE_BLOCK;

	get id(): string {
		return TourId.DESIGNER__RESIZE_BLOCK;
	}

	override get keyForPersistantDone(): string {
		return DesignerResizeBlockTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: true,
				attachTo: () => {
					return $('.gridboard-item .active').find('.dot-e');
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}
}
